import { TableHeader, TableHeaderDefs, TableHeaderDefsRow } from '../../types';
import { insertBlankCellsHeader } from '../special-headers';

export class ColspanBuilder {
  private explicitColspans: Map<number, number>;

  public init(explicitColspans: Map<number, number>): void {
    this.explicitColspans = explicitColspans;
  }

  public applyColspans(columns: TableHeaderDefs): void {
    for (const row of columns) {
      for (let columnIndex = 0; columnIndex < row.length; ) {
        const header: TableHeader = row[columnIndex];
        let colspan: number = this.explicitColspans.get(header?.column);

        if (colspan === undefined) {
          columnIndex++;
          continue;
        }

        colspan = Math.min(colspan, row.length - columnIndex);

        header.colspan = colspan;

        for (let span = 1; span < colspan; span++) {
          this.hideTableHeadAndKeepCells(columnIndex + span, row);
        }

        columnIndex += colspan;
      }
    }
  }

  private hideTableHeadAndKeepCells(columnIndex: number, row: TableHeaderDefsRow): void {
    const overwrittenHeader: TableHeader = row[columnIndex];

    if (!overwrittenHeader) {
      row[columnIndex] = insertBlankCellsHeader;
      return;
    }

    overwrittenHeader.colspan = 0;
  }
}
